import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { AsseMaintenanceCompleteApi } from "../../../services/AssetService"; // Adjust if needed

const AssetMaintenanceCompleteModal = ({
  id,
  open,
  onClose,
  afterSubmit,
  title = "Confirm Repair Completion",
  message = "Are you sure this asset's repair is completed?",
}) => {
  const [loading, setLoading] = useState(false);
  const [cost, setCost] = useState("");
  const [remark, setRemark] = useState("");
  useEffect(() => {
    if (open) {
      setCost("");
      setRemark("");
    }
  }, [open]);
  const handleConfirmRepair = () => {
    setLoading(true);
    AsseMaintenanceCompleteApi(id, { cost: cost, remarks: remark })
      .then((res) => {
        toast.success("Repair marked as complete successfully");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-success">
        <FaCheckCircle /> {title}
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 1,
            fontWeight: 500,
            color: "text.secondary",
          }}
        >
          {message}
        </Typography>

        <TextField
          autoFocus
          label="Maintenance Cost"
          fullWidth
          value={cost}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setCost(value);
            }
          }}
          placeholder="Enter Maintenance Cost"
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
        />

        <TextField
          label="Remarks"
          fullWidth
          value={remark}
          multiline
          rows={3}
          onChange={(e) => setRemark(e.target.value || "")}
          placeholder="Enter remarks..."
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleConfirmRepair}
          variant="contained"
          color="success"
          disabled={!cost}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetMaintenanceCompleteModal;
